module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAPCAYAAAA/I0V3AAAAAXNSR0IArs4c6QAAAUpJREFUOE+lkb9Lm1EYhZ9zozj0x2DpZil06JCtSIfSwQ8ydhCRDjVDNWjXIva/cCtCQfwCXQsBCyIqWNJObu0gQumonVIVDLFD+e6RFCNJ6odI73bPex7Oee8VfadU9YPM3gDuAfsx6NmXGf3otqlzGUv9RPij4YbgGOsN8qJhWHBK1PP6nOptv5LUC+DXhjt/BfSqIL5uV7RXqrqYmUfGy2qP4BBrSUkam8AOMAiMItf6K2NNInZtTgWP29BvrBfAiOX5f4BzQdZbxC/wygVUn9VqHtDRk9TlHuhWxtbJIOMyoR+W8c2M1eYAEz0QBb45+rsgXpJYIOghkaf/X+/ubdYbLYrdKSHQ+PRSP3N3uqSeLNc+VwrlfOiANe4z0p00lHGyOaujXOhaTz6Wxlaw39vhw1X/pBCnIiorSbN3oGlg4CoI+AOungHwdLXO+8JHEwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/menus_icon/ddgl_active.png
// module id = 11Ov
// module chunks = 3